import Locale from '../Locale';
import Index from '../Index';
import Edit from '../Edit';
import Report from '../Report';
import Metrics from '../components/report/metrics/Metrics';
import ResultsTable from '../components/report/individual/Main';
// import AnswersResume from '../components/report/resume/Resume';
// import ResumeEmail from '../components/report/optionEmails/Emails';
import Auth from '../Auth';
import NotFound from '../NotFound';

export default [
  {
    path: '/:locale',
    component: Locale,
    children: [
      { path: '', name: 'index', component: Index },
      { path: ':boxId/edit', name: 'boxEdit', component: Edit },
      {
        path: ':boxId/report/',
        name: 'boxReports',
        component: Report,
        children: [
          { path: '', component: Metrics, name: 'boxReportsMetrics' },
          { path: 'individuals', component: ResultsTable, name: 'boxReportsIndividuals' },
          // { path: 'resume', component: AnswersResume, name: 'boxReportsResume' },
          // { path: 'emails/:optionId', component: ResumeEmail, name: 'boxReportsEmails' },
        ],
      },
      { path: 'auth', name: 'auth', component: Auth },
    ],
  },
  { path: '*', name: 'not-found', component: NotFound },
];



/** WEBPACK FOOTER **
 ** ./src/router/routes.js
 **/